// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"40f85990","89":"9112d5fb","442":"3f47ee39","875":"940ecfa5"}[chunkId] + ".css";
};